<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';

  const lab = useMatrixFillLabContext();
</script>

<template>
  <div
    class="flex flex-col gap-2"
    data-testid="report-table"
  >
    <div class="flex items-center gap-2">
      <ColoredButton
        :text="lab.isExporting.value ? 'Gerando...' : 'Baixar Excel'"
        outlined
        :disabled="!lab.report.value || lab.report.value.rows.length === 0 || lab.isExporting.value"
        data-testid="report-export"
        @click="lab.exportReport"
      />
      <p
        v-if="lab.report.value"
        class="text-[var(--color-gray-05)]"
      >
        {{ lab.report.value.rows.length }} linha(s), {{ lab.report.value.columns.length }} coluna(s) visíveis para quem pede.
      </p>
    </div>

    <div
      v-if="lab.report.value"
      class="max-h-72 overflow-auto rounded-md border border-[var(--color-gray-02)]"
    >
      <table class="w-full border-collapse text-[10px]">
        <thead>
          <tr>
            <th class="border-b border-r border-[var(--color-gray-02)] bg-[var(--color-gray-09)] p-1 text-left">
              #
            </th>
            <th class="border-b border-r border-[var(--color-gray-02)] bg-[var(--color-gray-09)] p-1 text-left">
              Quem
            </th>
            <th
              v-for="column in lab.report.value.columns"
              :key="column.key"
              class="whitespace-nowrap border-b border-r border-[var(--color-gray-02)] bg-[var(--color-gray-09)] p-1 text-left"
            >
              {{ column.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in lab.report.value.rows"
            :key="index"
          >
            <td class="border-b border-r border-[var(--color-gray-02)] p-1">
              {{ index + 1 }}
            </td>
            <td class="whitespace-nowrap border-b border-r border-[var(--color-gray-02)] p-1">
              {{ lab.responses.value[index]?.subjectLabel }}
            </td>
            <td
              v-for="(cell, cellIndex) in row"
              :key="cellIndex"
              class="border-b border-r border-[var(--color-gray-02)] p-1"
            >
              {{ cell }}
            </td>
          </tr>
          <tr v-if="lab.report.value.rows.length === 0">
            <td
              :colspan="lab.report.value.columns.length + 2"
              class="p-2 text-center italic text-[var(--color-gray-05)]"
            >
              Nenhuma resposta salva. Salve um preenchimento para gerar a primeira linha.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
